

















import { Component, Vue } from 'vue-property-decorator';
import config from "../assets/js/config";
const Cookies = require("js-cookie");
const axios = require('../axios/index.js').default;

@Component
export default class WalletCard extends Vue{
    // computed 属性
    get balance(): number {
        return this.$store.state.balance || 0;
    }

    // computed 属性
    get currency(): number {
        return this.$store.state.currency || '';
    }

    // computed 属性
    get loginStaus(): boolean {
        return this.$store.state.isLogin;
    }

    // computed 属性
    get avatar(): boolean {
        return this.$store.state.avatar;
    }

    // computed 属性
    get username(): boolean {
        return this.$store.state.username;
    }

    mounted() {
        // console.log('this is mounted() in WalletCard');
    }

    // 清除数据
    clearData() {
        this.$store.dispatch('setCurrency', '');
        this.$store.dispatch('setBalance', 0);
        this.$store.dispatch('setInviteCode', '');
        this.$store.dispatch('setAvatar', '');
        this.$store.dispatch('setUsername', '');
    }

    loginOrOut() {
        let self = this;
        let loginMsg: any = {
            action: 'login',
            msg: ''
        }
        let logoutMsg: any = {
            action: 'logout',
            msg: ''
        }

        if(self.loginStaus) {
            self.$as.send('click_logout_btn_WalletCard');
            self.$JBH.sendMsg(JSON.stringify(logoutMsg), (res: any) => {
                // console.log('logout success resp: ', res);

                if(res === 'Success') {
                    self.$as.send('logout_successful_WalletCard');
                    self.$store.dispatch('setLogin', { flag:false });
                    self.clearData();
                    self.$router.push('/invite');
                }else{
                    self.$as.send('logout_failed_WalletCard');
                }
            });
        }else{
            self.$as.send('click_login_btn_WalletCard');
            self.$JBH.sendMsg(JSON.stringify(loginMsg), (res: any) => {
                // console.log('login success resp: ', res);
                let info: any = {};

                if (typeof res === "string") {
                    info = JSON.parse(res);
                } else {
                    info = res;
                }

                if (info.ref_token) {
                    self.$as.send('login_successful_WalletCard');
                    info.flag = true;
                    self.$store.dispatch("setLogin", info);
                    self.$bus.$emit('get-config');
                }else{
                    self.$as.send('login_failed_WalletCard');
                    info.flag = false;
                    self.$store.dispatch("setLogin", info);
                    self.clearData();
                }
            });
        }
    }
}
